import axios from '@/utils/request'

export default {
    // 2020-09-17
    search(params) {
        return axios.get('/balance-in-outs', params)
    },
    // 2020-09-17
    update(id, params) {
        return axios.put('/balance-in-outs/' + id, params)
    },
    // 2020-09-17
    delete(id) {
        return axios.delete('/balance-in-outs/' + id)
    },
    // 2020-12-03
    batchBalanceVerify(params) {
        return axios.put('/balance-in-outs/batch-balance-verify-agree', params)
    },
    // 2020-12-03
    balanceVerifyReject(id, params) {
        return axios.put('/balance-in-outs/' + id + '/balance-verify-reject', params);
    },

}

